<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Chart
	import LayerChartRenderer from '../Chart/LayerChart/LayerChartRenderer.svelte';
	import { getMonthlyReport } from 'src/helpers/statistics/core/consumptions/monthly_report_helpers';
	// Design system components
	import { ControlsContainer, Text } from '@Shelly/shelly-design-system';
	// Types
	import type { RequestMonthlyReport } from 'src/types/requests/charts/get_stats_period';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let result: RequestMonthlyReport,
		type: 'hour' | 'day' | 'week',
		currentTime: Date,
		currency: string;

	const totalDataKey = {
		hour: 'totalByHour',
		day: 'totalByDay',
		week: 'totalByWeekDay',
	};

	const chartTitles = {
		hour: {
			key: 'monthly_report_energy_by_hour',
			default: 'Average Energy By Hour',
		},
		day: {
			key: 'monthly_report_energy_consumed_day',
			default: 'Average Energy Consumed By Day',
		},
		week: {
			key: 'monthly_report_energy_by_week',
			default: 'Average Energy Consumed By Day',
		},
	};
</script>

<ControlsContainer color={$showNewLayout ? 'color-1' : 'color-2'}>
	<svelte:fragment slot="first">
		<Text class="text-bold mb-m mt-xs"
			>{$format(chartTitles[type].key, {
				default: chartTitles[type].default,
			})}</Text
		>
		<LayerChartRenderer
			chartData={getMonthlyReport(
				type,
				result?.report?.[totalDataKey[type]],
				currentTime.getFullYear(),
				currentTime.getMonth(),
				currency,
			)}
		/>
	</svelte:fragment>
</ControlsContainer>
